<template>
    <v-container fluid>
        <h1>Experiences</h1>
        <v-row justify="center" class="pa-3">
            <v-expansion-panels popout>
                <v-expansion-panel
                        v-for="(item,i) in items"
                        :key="i"
                >
                    <v-expansion-panel-header><span class="font-weight-medium">{{ item.title }}</span></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <span class="font-weight-light">{{ item.desc }}</span><br>
                        <span class=" font-italic" style="font-size: 11pt">{{ item.duration }}</span>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                items: [
                    {
                        title: "Web Master in ENT",
                        desc: "ENT or EEPIS NEWS AND NETWORK is a campus media for \n" +
                            "manage all information about PENS to external or internal\n" +
                            "and Network Team for manage campuses network.",
                        duration: "Sept 2018 - Now",
                    },
                    {
                        title: "Freelance in SBMPN 2020",
                        desc: "Platform for registration Fresh graduate High School\n" +
                            "student to vacational collage by paper test program.",
                        duration: "Apr 2020 - Now",
                    },
                    {
                        title: "Freelance in SNMPN 2020",
                        desc: "Platform for registration Fresh graduate High School\n" +
                            "student to vacational collage by invitation program.",
                        duration: "Dec 2019 - Mar 2020",
                    },
                    {
                        title: "Freelance in PMDK-PN 2019",
                        desc: "Platform for registration Fresh graduate High School\n" +
                            "student to vacational collage by invitation program.",
                        duration: "Dec 2018 - Apr 2019",
                    },
                    {
                        title: "Data Science Club PENS",
                        desc: "Club for learn about data science",
                        duration: "Ags 2019 - Now",
                    }
                ]
            }
        }
    }
</script>